import { render, staticRenderFns } from "./ShowGeneralInbookTab.vue?vue&type=template&id=16ac35ab&scoped=true"
import script from "./ShowGeneralInbookTab.vue?vue&type=script&lang=js"
export * from "./ShowGeneralInbookTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ac35ab",
  null
  
)

export default component.exports